import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './AdminSessionsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import moment from 'moment-timezone';

export function* getAdiminSessionsWatcher() {
  yield takeLatest(Actions.GET_ADMIN_SESSIONS_REQUEST, getAdminSessionsWorker);
}

export function* getSessionCreatorsWatcher() {
  yield takeLatest(Actions.GET_SESSION_CREATORS_REQUEST, getSessionCreatorsWorker);
}

export function* getAdminSessionsWorker(action) {
  try {
    let sessions = [];
    const {
      fromTime,
      toTime,
      limit,
      accountKey,
      page,
      filter,
      creators,
      registrantRange,
      attendeeRange,
      loadPage
    } = action.payload;
    const staffKeys = creators.map(creator => creator.staffKey).toString();
    const axiosResponse = yield call(
      ReportingRead.getAdminSessions,
      accountKey,
      fromTime,
      toTime,
      page,
      limit,
      filter,
      staffKeys,
      registrantRange,
      attendeeRange
    );
    const apiBody = axiosResponse.data;
    const { data, ...pagination } = apiBody;
    sessions = [...sessions, ...data];
    pagination.pageCount = Math.ceil(pagination.total / pagination.limit);
    yield put({
      type: Actions.GET_ADMIN_SESSIONS_SUCCESS,
      payload: { sessions, limit, fromTime, toTime, creators, registrantRange, attendeeRange, loadPage, pagination }
    });
    if (limit && limit === 10) {
      const { 0: lastSession = {}, [sessions.length - 1]: firstSession = {} } = sessions;
      const creatorsFromTime = firstSession.startTime ? firstSession.startTime : fromTime;
      const creatorsToTime = lastSession.startTime ? lastSession.startTime : toTime;
      const payload = { accountKey, fromTime: creatorsFromTime, toTime: creatorsToTime };
      yield fork(getSessionCreatorsWorker, { type: Actions.GET_SESSION_CREATORS_REQUEST, payload, accountKey });
    }
    if (limit) {
      let payload = yield select(getFromAndToTimeFromSessionReducer);
      yield fork(getTrendWorker, { type: Actions.GET_ADMIN_SESSIONS_TRENDS_REQUEST, payload, accountKey });
    } else {
      let payload = { fromTime: fromTime, toTime: toTime };
      yield fork(getTrendWorker, { type: Actions.GET_ADMIN_SESSIONS_TRENDS_REQUEST, payload, accountKey });
    }
  } catch (error) {
    yield put({ type: Actions.GET_ADMIN_SESSIONS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export function getFromAndToTimeFromSessionReducer(state) {
  const { fromTime, toTime } = state.reduced_admin_sessions.filter;
  return { fromTime, toTime };
}

function* getTrendWorker(action) {
  try {
    let fromTime = moment(action.payload.fromTime);
    let toTime = moment(action.payload.toTime);
    let range = fromTime.diff(toTime, 'days');
    let previousFromTime, previousToTime;
    let yearDays = moment().isLeapYear() ? 366 : 365;
    let trendResponse;
    if (range <= -364) {
      previousFromTime = moment()
        .subtract(Math.abs(range) * 2, 'd')
        .startOf('d');
      previousToTime = moment()
        .subtract(Math.abs(range) + 1, 'd')
        .endOf('d');
    } else {
      if (range === 0) {
        previousFromTime = moment(fromTime)
          .subtract(1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      } else if (range < -182) {
        previousFromTime = moment(fromTime)
          .subtract(yearDays - Math.abs(range) - 1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      } else {
        previousFromTime = moment(fromTime)
          .add(range - 1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      }
      trendResponse = yield call(
        ReportingRead.getAdminTrendComparisonData,
        action.accountKey,
        previousFromTime.toISOString(),
        previousToTime.toISOString()
      );
    }

    let trend = trendResponse ? trendResponse.data : { totalRegistrants: 'NA', totalAttendees: 'NA' };
    trend.prevDateRange = {
      previousFromTime: previousFromTime.toISOString(),
      previousToTime: previousToTime.toISOString()
    };

    yield put({
      type: Actions.GET_ADMIN_SESSIONS_TRENDS_SUCCESS,
      payload: { trend }
    });
  } catch (error) {
    yield put({ type: Actions.GET_ADMIN_SESSIONS_TRENDS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export function* getSessionCreatorsWorker(action) {
  try {
    let creators = [];
    const { accountKey, fromTime, toTime, page, filter, limit } = action.payload;
    const axiosResponse = yield call(
      ReportingRead.getSessionCreators,
      accountKey,
      fromTime,
      toTime,
      page,
      filter,
      limit
    );
    const apiBody = axiosResponse.data;
    const { data, ...pagination } = apiBody;
    creators = [...creators, ...data];
    yield put({
      type: Actions.GET_SESSION_CREATORS_SUCCESS,
      payload: { creators, page, filter, nextPage: pagination.next }
    });
  } catch (error) {
    yield put({ type: Actions.GET_SESSION_CREATORS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getAdiminSessionsWatcher), fork(getSessionCreatorsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminSessions/AdminSessionsSagas.js